import {Box, Typography} from '@mui/material';
import AurSvgIcon from '../../../common/aur-svg-icon/AurSvgIcon';
import {t} from 'i18next';
import {IFieldModal} from '../../../pages/field-management/custom-field/constant';

type ExportTagProps = {
  exportTagList: IFieldModal[];
};

const ExportTag = ({exportTagList}: ExportTagProps) => {
  return (
    <Box className="export-tag-container">
      <Box className="tag-title">
        <Typography className={`typo-text label2_size`}>
          {t('eca.documentPreviewer.taggingPanel.exportTags')}
        </Typography>
      </Box>
      {!exportTagList.length ? (
        <Box className="no-tag">
          <Typography className={`typo-text body2_size`}>
            {t('eca.documentPreviewer.taggingPanel.noTagApplied')}
          </Typography>
        </Box>
      ) : (
        <>
          {exportTagList.map((item, index) => (
            <Box
              className="tag-list-container"
              key={`tag-field-${item.fieldLabel}-${index}`}
            >
              <Box>
                <Typography className={`typo-text subhead3_size`}>
                  {item.fieldLabel}
                </Typography>
              </Box>
              {item.tagValues.map((tag, tagIndex) => (
                <Box className="tags" key={`tag-${tag.tagValue}-${tagIndex}`}>
                  <div className="icon">
                    <AurSvgIcon src="images/tag.svg" />
                  </div>
                  <Typography className={`typo-text body3_size`}>
                    {tag.tagValue}
                  </Typography>
                </Box>
              ))}
            </Box>
          ))}
        </>
      )}
    </Box>
  );
};

export default ExportTag;
